export default function Footer() {
  return (
    <footer className="bg-[#090c13] text-[#f4f9ff] rounded-window px-18 py-16 mt-24 grid gap-12">
      <h2 className="text-[clamp(3.8rem,6vw+1rem,5.8rem)] font-bold tracking-tighter m-0">
        BankStatementReader
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-11 text-[0.95rem] text-[rgba(228,233,245,0.88)]">
        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">
            Automated statement intelligence
          </strong>
          <p>
            Convert PDF bank statements into clean Excel, CSV, and JSON, with output you can verify against the original.
          </p>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Company</strong>
          <a href="/demo" className="block mb-2.5 hover:text-accent transition">Live Demo</a>
          <a href="/#features" className="block mb-2.5 hover:text-accent transition">Features</a>
          <a href="/#pricing" className="block mb-2.5 hover:text-accent transition">Pricing</a>
          <a href="/blog" className="block mb-2.5 hover:text-accent transition">Blog</a>
          <a href="/tools" className="block mb-2.5 hover:text-accent transition">Free Tools</a>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Support</strong>
          <a href="/security" className="block mb-2.5 hover:text-accent transition">Security</a>
          <a href="mailto:support@bankstatementreader.com" className="block mb-2.5 hover:text-accent transition">Contact Support</a>
        </div>

        <div>
          <strong className="block mb-4 text-[rgba(255,255,255,0.85)]">Legal</strong>
          <a href="/privacy" className="block mb-2.5 hover:text-accent transition">Privacy Policy</a>
          <a href="/terms" className="block mb-2.5 hover:text-accent transition">Terms of Service</a>
        </div>
      </div>

      <div className="flex justify-between text-[0.85rem] text-[rgba(228,233,245,0.66)]">
        <span>&copy; 2026 BankStatementReader. All rights reserved.</span>
        <span>Encryption in transit and at rest</span>
      </div>
    </footer>
  )
}
